import React, {useCallback, useContext, useEffect, useRef, useState} from 'react';
import "../css/GUIInstrumentRow.css";
import {getPortfolioHoldingQuantity,handleTradingsymbolClick} from '../../../services/apiService';  // Import the function to fetch querterlyHolding quantity
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import {handlePriceDifferenceChange} from "./InstrumentUtils";
import PriceDifferenceDisplay from "./PriceDifferenceDisplay";
import LastTradedPriceDisplay from "./LastTradedPriceDisplay";
import {TickProvider} from "../../../contexts/TickContext";
import "../css/MoreDetails.css";
import {DataContext} from "../../../contexts/DataContext";
import MoreDetailsLayout from "../../../marketwatch/gridcomponents/guiinstrumentrow/MoreDetails/MoreDetailsLayout";
import {useAnnouncementContext} from "@dashboard/contexts/ExchangeAnnContext";
import AnnouncementList from "@dashboard/grid-components/announcements/AnnouncementList";

const StagnantInstrumentRow = ({StagnantInstrument, uniqueId, onPriceDifferenceUpdate, setLayouts, layoutIndex}) => {
    const [holdingQuantity, setHoldingQuantity] = useState(null);  // State to store querterlyHolding quantity
    const [isFetching, setIsFetching] = useState(true);  // State to track fetching status
    const [priceColor, setPriceColor] = useState('black');  // Set default color for tradingsymbol
    const [lastPriceColor, setLastPriceColor] = useState('black');  // Set default color for last-traded-price
    const rowWrapperRef = useRef(null);
    const [isAnyPopupOpen, setIsAnyPopupOpen] = useState(false);
    const {screenerURLs} = useContext(DataContext);
    const [showAnnouncementDetails, setShowAnnouncementDetails] = useState(StagnantInstrument.instrumentEntity.forceShowAnnouncements || false);
    const {announcements, newAnnouncements, clearAnnouncements,isUnmounting,setIsUnmounting} = useAnnouncementContext();
    const hasNewAnnouncements = newAnnouncements && newAnnouncements.length > 0;

    useEffect(() => {
        setShowAnnouncementDetails(!!StagnantInstrument.instrumentEntity.forceShowAnnouncements);
    }, [StagnantInstrument.instrumentEntity.forceShowAnnouncements]);

    // Fetch querterlyHolding quantity when the component is mounted
    useEffect(() => {
        const fetchHoldingQuantity = async () => {
            const quantity = await getPortfolioHoldingQuantity(StagnantInstrument.instrumentEntity.tradingsymbol);
            setHoldingQuantity(quantity);
            setIsFetching(false);  // Mark as done fetching
        };

        fetchHoldingQuantity();
    }, [StagnantInstrument.instrumentEntity.tradingsymbol]);

// Use the utility function for price difference change
    const handlePriceDifference = useCallback(handlePriceDifferenceChange(onPriceDifferenceUpdate, StagnantInstrument.instrumentEntity), [
        StagnantInstrument.instrumentEntity.instrumentToken,
        onPriceDifferenceUpdate
    ]);
    const closeAllPopups = () => {
        setIsAnyPopupOpen(false);  // This could be passed to all popups
    };

    return (
        <TickProvider key={uniqueId} instrumentToken={StagnantInstrument.instrumentEntity.instrumentToken}
                      uniqueId={uniqueId}>
            <div className="gui-instrument-row-wrapper" ref={rowWrapperRef}>

                <div className="stagnant-instrument-row">
                    <div className="STAGC-instrument-row">
                        <div className="ss-instrument-info instrument-info">
                            <div className="symbol_n_exchange">
                    <span className="tradingsymbol" style={{color: priceColor}}
                          onClick={() => handleTradingsymbolClick(StagnantInstrument.instrumentEntity.tradingsymbol,screenerURLs)}>
                        {StagnantInstrument.instrumentEntity.tradingsymbol}
                    </span>
                                <span className="exchange-name">{StagnantInstrument.instrumentEntity.exchange}</span>
                            </div>
                            <PriceDifferenceDisplay
                                instrumentToken={StagnantInstrument.instrumentEntity.instrumentToken}
                                setPriceColor={setPriceColor}
                                setLastPriceColor={setLastPriceColor}  // Pass color change for last-traded-price
                                onPriceDifferenceChange={handlePriceDifference}
                                contextName={'TickContext'}
                            />
                            <div style={{width: '50px'}}>
                                <span></span>
                            </div>
                            <div className="querterlyHolding-quantity-1">
                                {!isFetching && holdingQuantity !== null && (
                                    <span
                                        /*style={{visibility: holdingQuantity === null ? 'hidden' : 'visible'}}*/>
                                            <ShoppingBagIcon style={{fontSize: '11px', verticalAlign: 'middle'}}/>
                                                {`\u00A0\u00A0${holdingQuantity}`}
                                     </span>
                                )}
                            </div>
                            <div className="mw-announcement-button-div">
                                <button
                                    className={`mw-announcement-button ${hasNewAnnouncements ? '' : 'is-hidden'}`}
                                >
                                    A
                                </button>
                            </div>
                            <LastTradedPriceDisplay
                                instrumentToken={StagnantInstrument.instrumentEntity.instrumentToken}
                                priceColor={lastPriceColor}  // Pass the color for last-traded-price
                                contextName={'TickContext'}
                            />
                            <div className="stagnant-details">
                                  <span className="stagnant-1YR-PrChg" style={{width: '113px'}}>
                                    <span className="stag_detail-label">1YR:</span> {/* Label with class */}
                                      <span className="stag_detail-value">{StagnantInstrument.trendlynePriceData._1Yr_change_perct || 0}%</span>
                                  </span>
                                  <span className="stagnant-1YR-PrChg" style={{width: '113px'}}>
                                    <span className="stag_detail-label">2YR:</span> {/* Label with class */}
                                      <span className="stag_detail-value">{StagnantInstrument.trendlynePriceData._2Yr_price_change_perct || 0}%</span>
                                  </span>
                                  <span className="stagnant-1YR-PrChg" style={{width: '113px'}}>
                                    <span className="stag_detail-label">3YR:</span> {/* Label with class */}
                                      <span className="stag_detail-value">{StagnantInstrument.trendlynePriceData._3Yr_price_change_perct || 0}%</span>
                                  </span>
                                  <span className="stagnant-1YR-PrChg" style={{width: '113px'}}>
                                    <span className="stag_detail-label">5YR:</span> {/* Label with class */}
                                      <span className="stag_detail-value">{StagnantInstrument.trendlynePriceData._5Yr_price_change_perct || 0}%</span>
                                  </span>
                                  <span className="stagnant-1YR-PrChg" style={{width: '113px'}}>
                                    <span className="stag_detail-label">10YR:</span> {/* Label with class */}
                                      <span className="stag_detail-value">{StagnantInstrument.trendlynePriceData._10Yr_price_change_perct || 0}%</span>
                                  </span>
                                  <span className="stagnant-1YR-PrChg" style={{width: '113px'}}>
                                    <span className="stag_detail-label">HalfYR:</span> {/* Label with class */}
                                      <span className="stag_detail-value">{StagnantInstrument.trendlynePriceData.half_Yr_Change_perct || 0}%</span>
                                  </span>
                                  <span className="stagnant-1YR-PrChg" style={{width: '113px'}}>
                                    <span className="stag_detail-label">QtrYR:</span> {/* Label with class */}
                                      <span className="stag_detail-value">{StagnantInstrument.trendlynePriceData.qtr_Change_perct || 0}%</span>
                                  </span>
                            </div>

                        </div>
                    </div>
                </div>
                {StagnantInstrument.instrumentEntity.isDetailsVisible && (
                    <div className="stag-more-details-layout-wrapper">
                    <MoreDetailsLayout
                        setLayouts={setLayouts}
                        instrumentToken={StagnantInstrument.instrumentEntity.instrumentToken}
                        layoutIndex={layoutIndex}
                        rowWrapperRef={rowWrapperRef}
                    />
                    </div>
                )}
                {showAnnouncementDetails && (
                    <AnnouncementList calledBy={"MW"}/>
                )}
            </div>

        </TickProvider>
    );
};

export default StagnantInstrumentRow;
